import React from 'react'
import { FormattedMessage } from 'react-intl'

export const CANCEL_CONFIRMATION_TITLE = (
    <FormattedMessage
        id='production_progress.cancel_confirmation_title'
        defaultMessage='Отмена подготовки'
    />
)
export const CANCEL_CONFIRMATION_SUBMIT = (
    <FormattedMessage
        id='production_progress.cancel_confirmation_submit'
        defaultMessage='Отменить подготовку'
    />
)

export const CANCEL_CONFIRMATION_CANCEL = (
    <FormattedMessage
        id='production_progress.cancel_confirmation_cancel'
        defaultMessage='Закрыть'
    />
)

export const CANCEL_CONFIRMATION_CONTENT = (
    <FormattedMessage
        id='production_progress.cancel_confirmation_content'
        defaultMessage='Подтвердите отмену подготовки резервов.{newLine}Затраченный на подготовку промресурс будет возвращён на склад.' // eslint-disable-line max-len
        values={{
            newLine: <br/>,
        }}
    />
)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/CancelConfirmation/constants.jsx